import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { _FunctionalID, _NoveltyAccount, _OutputAuthorizationRequest, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import useModal, { MODAL_LG } from "../../../../../theme/Component/hooks/useModal";
import { Modal } from "../../../../../theme/Component/Modal";
import { OutputAuthorizationItem } from "../../../../../Inventories-Warehouses/OutputAuthorizationRequest/OutputAuthorizationItem/OutputAuthorizationItem";
import { VisorAnyDocument } from "../../../../../documents/VisorAnyDocument";
import { Alert } from "../../../../../theme/Component/Alert";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

interface Resp {
    Obs: string;
    Aprove: string;
}

type SignedApprove = {
    IDAccount: number;
    Approved: boolean;
    Date: string;
};

export const SOLAUTSAL004 = ({ configProcedure }: Props) => {

    const props = configProcedure?._pocessData?.Props ?? {};

    const { instance, bean, setBean } = useDataBean(_OutputAuthorizationRequest)

    const [obs, setObs] = useState<string>("")

    useEffect(() => {
        if (props.IDOutputAuthorizationRequest) {
            instance.getOutputAuthorizationRequest(props.IDOutputAuthorizationRequest).then(
                (resp) => {
                    setBean(resp)
                }
            ).catch(err => { toast.error("No se pudo Cargar la informacion de la solicitud, intentelo mas tarde") })
        }
    }, [props.IDOutputAuthorizationRequest])

    const onExportMap = () => {
        configProcedure?._pushInfo?.(obs);

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap({
                Returned: true,
                Descriptio: obs
            })
        }
    }

    const updateTramite = () => {
        const x = { ...bean, State: 103 };

        instance.updateOutputAuthorizationRequest(x).then(
            (resp) => {
                onExportMap();
            }
        ).catch(err => { toast.error("No se pudo realizar la accion") })
    }

    return (
        <div className="row">
            <div className="col-md-12" style={{ maxHeight: "700px", overflow: "auto" }}>
                <Alert children={`Una vez confirmada la devolución, el trámite se dará por finalizado`} clase="info" />
            </div>
            <div className="col-md-12">
                <label>Observaciones</label>
                <textarea className="form-control" value={obs} onChange={(e) => { setObs(e.target.value) }} />
            </div>
            <div className="col-md-4">
                <BasicButton useMargin eventClick={() => { updateTramite() }} icon="ri-send-plane-line"  >Confirmar Devolucion de Equipo</BasicButton>
            </div>
        </div>
    );
}